/**
 * Renders a generic Sidebar
 */
import React from 'react';
import {Link} from 'react-router';
import classNames from 'classnames';

import 'styles/utils/Sidebar.styl';

class Sidebar extends React.Component {
  /**
   * Handle clicking on a sidebar link
   */
  handleClick(event, linKName) {
    // call handler if defined
    if (this.props.onClickLink) {
      this.props.onClickLink(event, linKName);
    }
  }

  renderMenu(menu, topLevel) {
    const menuClassName = classNames('menu', {
      'sub-menu': !topLevel,
    });

    if (menu && !menu.isEmpty()) {
      return (
        <div className={menuClassName}>
          {menu.map((item, i) => {
            // check if any child link is active
            const currentTabLocation = window.location.pathname;
            const childActive =
              item.children && item.children.some(elem => elem.url === currentTabLocation);

            const linkContainerClassName = classNames('link-container', {
              'child-active': childActive,
            });

            const linkClassName = classNames('link', {
              'disabled-link': item.disabled,
              parent: item.children,
            });

            return (
              <div className={linkContainerClassName} key={i}>
                <Link
                  key={i}
                  data-key={item.name}
                  to={item.url}
                  className={linkClassName}
                  activeClassName="active"
                  onClick={event => this.handleClick(event, item.name)}>
                  {item.name}
                </Link>
              </div>
            );
          })}
        </div>
      );
    }
  }

  render() {
    return (
      <div className={classNames('app-sidebar', {hidden: this.props.hideSidebar})}>
        {this.renderMenu(this.props.sidebarMenu, true)}
        {this.props.children}
      </div>
    );
  }
}

export default Sidebar;
